"use client";

import { useScrolledAttribute } from "@/hooks/useScrolledAttribute";
import styles from "./Navbar.module.scss";

type LandingNavbarProps = {
  logos: JSX.Element;
};

export const LandingNavbarClient = ({ logos }: LandingNavbarProps) => {
  const navRef = useScrolledAttribute<HTMLElement>();

  return (
    <nav
      ref={navRef}
      data-scrolled={false}
      className={`${styles["landing-navbar"]} navbar`}
    >
      <div className={styles["landing-navbar-shell"]}>{logos}</div>
    </nav>
  );
};
